
<template>
  <!--消息模板-->
  <div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :dataSource="dataSource"
      rowKey="tpl_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'msgTemplate',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '模板ID、模板标题', inputType: 'input' },
        { props: ['type'], placeholder: '消息类型', options: [], inputType: 'select' },
        { props: ['update_time'], placeholder: ['修改时间', '修改时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:msgTemplate:add'] }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['community:msgTemplate:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), permi: ['community:msgTemplate:remove'] }
      ],
      columns: [
        { title: '模板ID', dataIndex: 'tpl_mark', align: 'left', width: '' },
        { title: '消息类型', dataIndex: 'category_title', align: 'left', width: '' },
        { title: '模板标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '修改时间', dataIndex: 'update_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        type: '',
        update_time: ''
      },
      listApi: {
        url: 'message_tpl',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addMsgTemplate',
        addTitle: '新增模板',
        editTitle: '修改模板'
      },
      deleteParam: {
        url: '/message_tpl/',
        param: { pk_key: 'tpl_id', pk_val: '' },
        title: '消息模板',
        key: 'title'
      }
    };
  },
  mounted () {
    let paramArr = [{ index: 1, key: 'msg_type' }];
    this.marketingManageSelect(paramArr);
  },
  methods: {
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
